module.exports = __webpack_public_path__ + "img/q4.a975cbbc.gif";